import { useMemberExtract } from 'contexts/MemberExtract';
import React from 'react';
import Row from './RowHistory';
import ShowMore from './ShowMore';

function TableHistory() {
  const { memberHistory } = useMemberExtract();

  const histories = memberHistory.transactionsPurchaseMiles;

  return (
    <div className="corporate-club-extract__card__body__table">
      <div className="corporate-club-extract__card__body__table__rows">
        {histories.map((history) => (
          <Row key={history.id} history={history} />
        ))}
      </div>
      <ShowMore />
    </div>
  );
}

export default TableHistory;
